import { BaseValue } from "../../consts/base-value";
import { EnvState } from "../env-state";
import { ServiceNameState } from "./service-name-state";
import { RedirectPath } from "./redirect-path";
import { checkGrafferUrl } from "../url-util";

const defaultUrl = "/services";

export class RedirectUrl extends BaseValue<string> {
  static createDefault() {
    return new RedirectUrl(defaultUrl);
  }
  static create(
    envState: EnvState,
    serviceNameState: ServiceNameState,
    redirectPath: RedirectPath,
  ) {
    const url = serviceNameState.match({
      default: () => defaultUrl,
      ttzk: () =>
        this.makeRedirectURL("ttzk.graffer.jp", envState, redirectPath),
      smart: () =>
        this.makeRedirectURL("ttzk.graffer.jp", envState, redirectPath),
      "booth-reserve": () =>
        this.makeRedirectURL("ttzk.graffer.jp", envState, redirectPath),
      "console-graffer-staff": () =>
        this.makeRedirectURL("cloud-gov.graffer.jp", envState, redirectPath),
      "registry-certs": () =>
        this.makeRedirectURL(
          "registry-certs.graffer.jp",
          envState,
          redirectPath,
        ),
      "e-cert": () =>
        this.makeRedirectURL("e-cert.graffer.jp", envState, redirectPath),
      dashboard: () =>
        this.makeRedirectURL("dashboard.graffer.jp", envState, redirectPath),
      "proc-search": () =>
        this.makeRedirectURL("ttzk.graffer.jp", envState, redirectPath),
      "corporate-site": () => {
        // コーポレートサイトのURLは現時点で揃っていないので、個別対応
        return envState.matchSandbox({
          production: () => "https://graffer.jp",
          staging: () => "https://staging.graffer.jp",
          development: () => "https://dev.graffer.jp",
          sandbox: () => "https://graffer.jp",
        });
      },
    });
    return new RedirectUrl(url);
  }
  private static makeRedirectURL(
    baseDomain: string,
    envState: EnvState,
    redirectPath: RedirectPath,
  ) {
    const prefix = envState.getPrefix();
    const redirectParams = redirectPath.getValue();
    const url = `https://${prefix}${baseDomain}${redirectParams}`;
    if (!checkGrafferUrl(url)) {
      throw new Error(
        `Invalid redirectPath: [${prefix}][${baseDomain}][${redirectParams}]`,
      );
    }
    return url;
  }
  matchUrl<R>(matcher: { [key in "default" | "service"]: () => R }): R {
    if (this.getValue() === defaultUrl) {
      return matcher.default();
    }
    return matcher.service();
  }
}
